import React from 'react';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';
import CircleButton from '../../shared/CircleButton';
import downloadIcon from '../../../../assets/images/icons/trail/icons-buttons-save-map.svg';
import printIcon from '../../../../assets/images/icons/trail/icons-buttons-print.svg';
import { mapActionButton, container } from './styles.module.scss';

const CtaControls = ({ handleSaveClick, handlePrintClick }) => {
  return (
    <div className={container}>
      {handleSaveClick && (
        <CircleButton
          large
          icon={downloadIcon}
          className={mapActionButton}
          onClick={wrapEventHandler(handleSaveClick)}
          title={StringConstantsMixin.strings.TRACK_DETAIL.SAVE_TO_MAPS}
        />
      )}
      {handlePrintClick && (
        <CircleButton
          large
          icon={printIcon}
          className={mapActionButton}
          onClick={wrapEventHandler(handlePrintClick)}
          title={StringConstantsMixin.strings.PRINT_MAP}
        />
      )}
    </div>
  );
};

export default CtaControls;
